import styled, { css } from 'styled-components';
import { assetPath } from '../../../utils/web-helper';
import * as C from '../../loggedout/shared-styles/Colors'
import FontGraphie from '../../loggedout/shared-styles/graphieFont';
import SplashLearnUniverseBackgrounds from '~images/parent-signup/SplashLearn_Universe_Background.png'
import ParentSgnupImage from '~images/parent-signup/ParentSignupImage.png';
import { breakpoints, device, getWidthRange } from '../../../utils/responsive_utilities';

export const ParentCreationContainer = styled.div`
  @media ${getWidthRange(0, 600)} {
    margin-top: -55px;
  }
`;

export const ParentSignupWrapper = styled.div`
  padding-top: 7.8rem;
  min-height: 74rem;
  width: 100%;
  display: flex;
  background: url(${assetPath(SplashLearnUniverseBackgrounds)}) no-repeat;
  background-size : cover;

  @media ${getWidthRange(0, breakpoints.md)} {
    padding-top: 6.9rem;
  }
`;
export const ParentSignupContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  background-color: ${C.white};
  border-radius: 1.2rem;
  padding: 4.6rem 4.6rem;
  margin: 5.1rem auto;
  min-width: 103rem;

  @media ${device.Tablet} {
    min-width: auto;
    margin: 3.6rem auto;
    padding: 3.6rem 7rem;
  }

  @media ${getWidthRange(0, breakpoints.md)} {
    min-width: 100%;
    margin: 0;
    padding: 2.2rem 1.8rem;
    border-radius: 0;
  }
`;
export const ParentSignupTitleText = styled.h1`
  ${FontGraphie(3.0,1.3,7)};
  color: ${C.deepCoveDark};
  margin-bottom: 4rem;
  text-align: center;
  
  @media ${getWidthRange(0, breakpoints.md)} {
    margin: 0 1.2rem;
  }
`;
export const SignupContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  
  @media ${getWidthRange(0, breakpoints.lg)} {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

export const SignupContainerLeftPanel = styled.div`
  width: 40%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${getWidthRange(0, breakpoints.lg)} {
    align-items: center;
    margin-top: 2rem;
    width: 100%;
  }
`;
export const ParentStudentSignupImage = styled.div`
  width: 40.8rem;
  height: 37.4rem;
  background: url(${assetPath(ParentSgnupImage)}) no-repeat;
  background-size: contain;
  margin-bottom: 1rem;

  @media ${getWidthRange(breakpoints.md, breakpoints.xl)} {
    width: 29.3rem;
    height: 26.8rem;
  }

  @media ${getWidthRange(0, breakpoints.sm)} {
    width: 18.6rem;
    height: 17.1rem;
  }
`;
export const ParentSignupSubText = styled.div`
  ${FontGraphie(1.8,1.2,6)};
  color: ${C.codGrey};
  margin-bottom: 1.5rem;
`;
export const SignupBenefitsContainer = styled.div`
  background: ${C.lightPinkGrey};
  border-radius: 0.6rem;
  padding: 2.9rem;
  width: 41.6rem;
  max-width: 44.6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  @media ${getWidthRange(0, breakpoints.sm)} {
    width: 100%;
  }
`;
export const SignupBenefit = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: center;
  @media ${getWidthRange(0, breakpoints.sm)} {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const SignupBenefitIcon = styled.img`
  height: 3.2rem;
  width: 3.2rem;
`;
export const SignupBenefitText  = styled.div`
  ${FontGraphie(1.4,1.2,4)};
  color: ${C.blackLight};
  max-width: fit-content;
`;

export const VerticalRule = styled.div`
  height: 100%;
  border-right: 0.1rem solid ${C.lightBlueGrey};
`;

export const SignupContainerRightPanel = styled.div`
  width: 54%;
  min-width: 51rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media ${getWidthRange(0, breakpoints.lg)} {
    align-items: center;
    margin-top: 2rem;
    width: 100%;
  }
`;
export const SocialSignupGroupContainer = styled.div`
  display: flex;
  justify-content: center;

  & > *+* {
    margin-left: 2rem; 
  }
  
  @media ${getWidthRange(0, breakpoints.md)} {
    flex-direction: column;
    align-items: center;

    & ~ ${SocialSignupLinkButton} {
      width: 27.2rem;
    }

    & > *+* {
      margin-left: 0; 
      margin-top: 2rem;
    }
`;
export const SocialSignupLinkButton = styled.button`
  display: flex;
  align-items: center;
  width: 24.6rem;
  height: 6rem;
  border-radius: 3rem;
  padding: 1.1rem;
  border: none;
  ${props => {
    switch(props.link){
      case "google": return css`
        background-color: ${C.ctaSkyBlue};
      `
      case "apple": return css`
        background-color: ${C.pureBlack};
      `
    }
  }};


  @media ${getWidthRange(0, breakpoints.xl)} {
    height: 4.8rem;
    padding: 0.6rem;
    border-radius: 2.4rem;
  }
  @media ${getWidthRange(0, breakpoints.md)} {
    width: 27.2rem;
  }
`;
export const SocialLinkImage = styled.div`
  height: 3.8rem;
  width: 3.8rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => {
    switch(props.link){
      case "google": return css`
        background-color: ${C.white};
      `
      case "apple": return css`
        background-color: ${C.pureBlack};
      `
    }
  }};
  & img{
    height: inherit;
  }

  @media ${getWidthRange(0, breakpoints.xl)} {
    height: 3.6rem;
    width: 3.6rem;
    & img{
      height: 3.2rem;
    }
  }
`;
export const SocialLinkText = styled.div`
  color: ${C.white};
  text-decoration: none;
  padding-left: 2.1rem;
  font-family: 'Roboto';
  font-size: 1.6rem;
  line-height: 1.875rem;
  font-weight: 500;
`;
export const OrBar = styled.div`
  width: 47.2rem;
  display: flex;
  justify-content: center;
  margin: 2rem;
  border-bottom: 0.1rem solid ${C.lightBlueGrey};

  @media ${getWidthRange(0, breakpoints.md)}{
    border-bottom: none;
  }
}
`;
export const OrText = styled.div`
  ${FontGraphie(1.6,1.2,4)};
  background: ${C.white};
  padding: 0 1rem;
  margin-bottom: -1rem;
  color: ${C.black};
`;
export const ParentSignupFormContainer = styled.div`
  width: 84%;
`;

export const TeacherSignupLink = styled.a`
  ${FontGraphie(1.6,1.2,4)};
  color: ${C.indigo};
  margin-top: ${props => props.extraMargin ? "5.6rem" : "2.4rem"};
  margin-bottom: 3.5rem;
  text-decoration: underline;
`;

export const TermsAndPolicyWarning = styled.div`
  ${FontGraphie(1.4,1.2,4)};
  color: ${C.black};

  & a:{
    color: ${C.indigo};
  }
`;
export const PolicyAndNewsLetterBox = styled.div`
  width: 84%;
  ${FontGraphie(1.4,1.2,4)};
`

export const Choice = styled.div`
  margin-bottom: 2rem;
  display: flex;
`
export const Label = styled.span`
  text-align: left;
`
export const AsteriskSign = styled.span`
  color: red;
`
export const LabelText = styled.span`
  color: ${C.warmBlack};
  font-size: 1.4rem;
  text-align: left;
  >a{
    color: ${C.indigo};
  }
`
export const CheckBox = styled.input`
  margin-right: 1.7rem;
  margin-top: 0.3rem;
  height: 2rem;
  width: 2rem;
  align-self: flex-start;
  display: inline-block;
  flex-shrink: 0;
  border-radius: 0.2rem;
  accent-color: ${C.indigo};
`